// Enhanced function to handle both carousel navigation links and internal page links
export function setupCarouselLinks() {
    document.addEventListener('click', (event) => {
        const anchor = event.target.closest('a');
        if (!anchor) return;
        
        // Don't interfere with special clicks
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) {
            return;
        }
        
        // Handle data-slide-index links (existing functionality)
        const slideIndex = anchor.getAttribute('data-slide-index');
        if (slideIndex) {
            event.preventDefault();
            if (window.appNavigation && typeof window.appNavigation.goToPage === 'function') {
                window.appNavigation.goToPage(slideIndex);
            }
            return;
        }
        
        // Handle internal /pages/ links
        const href = anchor.getAttribute('href');
        if (href && href.startsWith('/pages/')) {
            // Extract the slug from the URL
            const match = href.match(/^\/pages\/(.+)$/);
            if (match) {
                const slug = match[1];
                event.preventDefault();
                
                // Use the navigation function to slide to the page
                if (window.appNavigation && typeof window.appNavigation.goToPage === 'function') {
                    window.appNavigation.goToPage(slug);
                }
            }
        }
    });
}
